import { useEffect, useState } from 'react';
import styled from 'styled-components';
import ApprenticeMatrix from '../ApprenticeMatrix';
import mapSelectBoxOptions from '~/helpers/renderer/mapping/mapSelectBoxOptions';
import fetchLinks from '~/api/helpers/fetchLinks';
import { useIntl } from 'react-intl';

const Div = styled.div`
  width: 100%;
`;

/**
 * @param {ApprenticeMatrixSearchProps} props
 * @returns {React.ReactElement} The rendered component
 */
function ApprenticeMatrixSearch({
  searchId,
  groupId,
  subGroupId,
  locationId,
  initialResult = {
    groups: [],
    items: [],
  },
  isBrand,
}) {
  const [result, setResult] = useState(initialResult);
  const [locations, setLocations] = useState();
  const intl = useIntl();

  /**
   * @param {string | DataQuery | undefined} [query]
   * @returns {Promise<{groups: DataSearchGroup[], items: MatrixItemApiProps[]}>}
   */
  const fetchData = (query) => {
    return fetchLinks(searchId, {
      query,
      groups: [
        {
          categoryIds: [locationId],
          withCounts: false,
          withItems: false,
        },
        {
          categoryIds: [groupId, subGroupId],
          withCounts: true,
          withItems: true,
        },
      ],
    });
  };

  // Initial fetch
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    fetchData().then((val) => setResult(val));
  }, []);
  /* eslint-enable react-hooks/exhaustive-deps */

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (result && !locations) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setLocations(result?.groups?.[0]);
    }
  });
  /* eslint-enable react-hooks/exhaustive-deps */

  const mainGroup = result?.groups?.[1];
  const { items } = result;

  return (
    <Div>
      <ApprenticeMatrix
        selectBoxProps={{
          options: mapSelectBoxOptions(locations?.terms),
          handleSelect: async (obj) => {
            const { value } = obj;
            const newResult = await fetchData(value);
            // TODO: check if still is mount
            setResult(newResult);
          },
          deselectOption: {
            description: intl.formatMessage({
              id: 'apprMtrx.LocationDeselectDescription',
            }),
            handleSelect: async () => {
              const newResult = await fetchData();
              // TODO: check if still is mount
              setResult(newResult);
            },
          },
        }}
        results={
          mainGroup?.terms.map((group) => ({
            description: `${group.label} (${group.subgroup?.count})`,
            column: {
              introText: group.description ?? '',
              blocks:
                group.subgroup?.terms.map((subGroup) => ({
                  headline: subGroup.label,
                  linkList:
                    subGroup.itemIds?.map((itemId) => {
                      const item = items.find((it) => it.id === itemId);
                      return {
                        icon: 'ARROW_ANIMATION',
                        href: item?.link.url ?? '',
                        text: item?.link.text ?? item?.link.url ?? '',
                        title: item?.link.title ?? '',
                      };
                    }) ?? [],
                })) ?? [],
            },
          })) ?? []
        }
        isBrand={isBrand}
      />
    </Div>
  );
}

export default ApprenticeMatrixSearch;
